import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import CheckboxTree from 'react-checkbox-tree';

import ModalStepBase from '../ModalStepBase';
import ItemSelecionarConteudo from '../shared/conteudo/ItemSelecionarConteudo';
import ModalDetalheConteudo from './ModalDetalheConteudo';
// import ItemSelecionarQuestao from '../shared/conteudo/ItemSelecionarQuestao';
// import ModalDetalheQuestao from './ModalDetalheQuestao';
import Alert from 'react-s-alert';

const isMobile = require('ismobilejs');

class ModalAddEstudo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModalVisualizarConteudo: false,
            showModalVisualizarQuestao: false,
            treeViewAlunosEstudo: {},
            treeViewConteudos: {
                checked: [],
                expanded: [],
            },
            // {"id":63,"img":"https://dev-image.edebe.com.br/192x144/smart/e/img/cover/mfs2/001.png","titulo":"Raios X e raios gama","porcentagem":0,"tipo":"MDD","descricaoTipo":"Material Didático Digital","detalhes":"","disciplina":"Física"}
            // conteudos: [
            //     { img: "", tipo: "MDD", titulo: "Os tipos de conjunto", dificuldade: "Intermediário", disciplina: "Matemática e Geografia", porcentagemDeficiencia: 80, habilidades: ["H1 - Utilizar no contexto social diferentes significados e representações dos números — naturais, inteiros, racionais ou reais.", "H2 - Utilizar algum procedimentos de cálculo com números naturais, inteiros, racionais ou reais."] },
            //     { img: "/images/estudos/estudo2.png", tipo: "Vídeo", titulo: "Logarítimos", dificuldade: "Difícil", disciplina: "Matemática", porcentagemDeficiencia: 60, habilidades: ["H1 - Utilizar no contexto social diferentes significados e representações dos números — naturais, inteiros, racionais ou reais.", "H2 - Utilizar algum procedimentos de cálculo com números naturais, inteiros, racionais ou reais."] },
            //     { img: "/images/estudos/estudo1.png", tipo: "MDD", titulo: "Álgebra Linear", dificuldade: "Intermediário", disciplina: "Matemática", porcentagemDeficiencia: 0, habilidades: ["H1 - Utilizar no contexto social diferentes significados e representações dos números — naturais, inteiros, racionais ou reais.", "H2 - Utilizar algum procedimentos de cálculo com números naturais, inteiros, racionais ou reais."] },
            // ],
            conteudos: [],
            questoes: [],
            loadingFinalizar: false,
            inHasSummary: false
        }

        this.onChangeDtFim = this.onChangeDtFim.bind(this);
        this.onChangeDtInicio = this.onChangeDtInicio.bind(this);
        this.onClickVisualizarConteudo = this.onClickVisualizarConteudo.bind(this);
        this.onCloseModalVisualizarConteudo = this.onCloseModalVisualizarConteudo.bind(this);
        this.onCheckTree = this.onCheckTree.bind(this);
        this.onClickVisualizarQuestao = this.onClickVisualizarQuestao.bind(this);
        this.onCloseModalVisualizarQuestao = this.onCloseModalVisualizarQuestao.bind(this);
        this.onCrearEstudoFinalizar = this.onCrearEstudoFinalizar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }



    onCheckTree(checked, targetNode) {
        // segmento
        if (targetNode.treeDepth === 0) {
            if (targetNode.checked) {
                targetNode.children.forEach(serie => {
                    serie.children.forEach(el => {
                        checked = this.addToArray(checked, el.value)
                    })
                })
            }
            else {
                targetNode.children.forEach(serie => {
                    serie.children.forEach(el => {
                        checked = this.removeFromArray(checked, el.value)
                    })
                })
            }
        }
        // série
        if (targetNode.treeDepth === 1) {
            if (targetNode.checked) {
                targetNode.children.forEach(el => {
                    checked = this.addToArray(checked, el.value)
                })
            }
            else {
                targetNode.children.forEach(el => {
                    checked = this.removeFromArray(checked, el.value)
                })
            }
        }
        // turma
        if (targetNode.treeDepth === 2) {
            if (targetNode.checked) {
                checked = this.addToArray(checked, targetNode.value)
            }
            else {
                checked = this.removeFromArray(checked, targetNode.value)
            }
        }
        this.props.practiceContainer.setState({ treeViewAlunosEstudo: { ...this.props.practiceContainer.state.treeViewAlunosEstudo, checked } })
    }


    removeFromArray = (array, element) => {
        return array.filter(el => el !== element);
    }
    addToArray = (array, element) => {
        if (array.indexOf(element) === -1) array.push(element);
        return array;
    }
    componentDidMount() {
        console.log('componentDidMount');
        // let inHasSummary = this.props.practiceContainer.state.study.inHasSummary;
        this.props.practiceContainer.getAlunosEscola();
    }

    async componentDidUpdate(nextProps) {
        if (nextProps.loadingFinalizar !== this.props.loadingFinalizar && nextProps.loadingFinalizar === false) {
            this.setState({ loadingFinalizar: false })
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === 'inHasSummary') {
            this.setState({ inHasSummary: !this.state.inHasSummary })
        }
        this.props.practiceContainer.setState({
            study: { ...this.props.practiceContainer.state.study, [name]: value }
        });
        //  console.log([name] + " : " + value);
        this.configChanged = true
    }


    onClickVisualizarConteudo() {
        this.setState({ showModalVisualizarConteudo: true });
    }

    onCloseModalVisualizarConteudo() {
        this.setState({ showModalVisualizarConteudo: false });
    }

    onClickVisualizarQuestao() {
        this.setState({ showModalVisualizarQuestao: true });
    }

    onCloseModalVisualizarQuestao() {
        this.setState({ showModalVisualizarQuestao: false });
    }

    async onCrearEstudoFinalizar() {
        // console.log('onCrearEstudoFinalizar')
        this.setState({ loadingFinalizar: true })
        // console.log('props ', this.props)
        // console.log('stiudy ', this.props.practiceContainer.state.study)
        /**
         * validate initial date
         */
        let validStartDate = await this.isValidStartDate(this.props.practiceContainer.state.study.dtStartStudy);
        if (!validStartDate) {
            Alert.info('Informe uma data de início que esteja no ano corrente.')
            this.setState({ loadingFinalizar: false })
            return;
        }

        let validEndDate = await this.isValidEndDate(this.props.practiceContainer.state.study.dtEndStudy);
        if (!validEndDate) {
            Alert.info('Informe uma data e hora de término do estudo maior que a data corrente')
            this.setState({ loadingFinalizar: false })
            return;
        }

        var hours = Math.abs(this.props.practiceContainer.state.study.dtEndStudy - this.props.practiceContainer.state.study.dtStartStudy) / 36e5;

        if (hours <= 0) {
            Alert.info('Informe um intervalo de datas válido para o estudo.')
            this.setState({ loadingFinalizar: false })
            return;
        }

        let account_checked = [];
        account_checked = this.props.practiceContainer.state.treeViewAlunosEstudo.checked

        // console.log('account_checked ', account_checked)
        // console.log('account_checked join ', account_checked.join())

        if (account_checked.length > 0) {
            this.props.practiceContainer.state.study.idUserMember = account_checked.join();

            this.finishModal()

        } else {

            Alert.info('Selecione pelo menos um aluno ou turma!')
            this.setState({ loadingFinalizar: false })
        }

    }
    async finishModal() {
        this.props.onClickAddConteudo(true);

//        this.setState({ loadingFinalizar: false })
    }

    async isValidStartDate(start) {
        let validStartDate = false;
        let currentDate = await this.props.practiceContainer.getCurrentDateHour();

       if(currentDate.getFullYear() === start.getFullYear()){
          // console.log('dta inicio valida')
        validStartDate = true;
       }
       return validStartDate;
    }

    async isValidEndDate(end) {
        let validEndDate = false;
        let currentDate = await this.props.practiceContainer.getCurrentDateHour();

       if(end > currentDate){
          // console.log('dta inicio valida')
        validEndDate = true;
       }
       return validEndDate;

    }

    onChangeDtInicio(date) {
        //Caso tenha selecionado uma data inicial maior que a final
        if (date.getTime() > this.props.practiceContainer.state.study.dtEndStudy.getTime()) {
            this.props.practiceContainer.setState({
                study: { ...this.props.practiceContainer.state.study, dtStartStudy: date, dtEndStudy: date }
            });
        }
        else {
            this.props.practiceContainer.setState({
                study: { ...this.props.practiceContainer.state.study, dtStartStudy: date }
            });
        }
    }

    onChangeDtFim(date) {
        //Caso tenha selecionado uma data final menor que a inicial
        if (date.getTime() < this.props.practiceContainer.state.study.dtStartStudy.getTime()) {
            this.props.practiceContainer.setState({
                study: { ...this.props.practiceContainer.state.study, dtStartStudy: date, dtEndStudy: date }
            });
        }
        else {
            this.props.practiceContainer.setState({
                study: { ...this.props.practiceContainer.state.study, dtEndStudy: date }
            });
        }
    }

    render() {
        const study = this.props.practiceContainer.state.study || {}
        var treeViewAlunosEstudo = this.props.practiceContainer.state.treeViewAlunosEstudo
        // console.log('this.props.study',this.props.study)

        return (
            <React.Fragment>
                <ModalStepBase loadingFinalizar={this.state.loadingFinalizar} onClickFinish={this.onCrearEstudoFinalizar} {...this.props}
                    stepsContent={[
                        {
                            title: "Configurar Estudo",
                            content: (<div>
                                <h4 className="edb-text-bold edb-margin-none">Configurar Estudo</h4>

                                <div className="edb-row edb-margin-large-top">
                                    <div className="edb-col s6">


                                        <div className="adap-input-icon-container">
                                            <label className="edb-margin-small-top">
                                                <input id="chk_resumo" type="checkbox" name="inHasSummary" checked={this.state.inHasSummary} onChange={this.handleInputChange} />
                                                <span htmlFor="chk_resumo">Habilitar resumo</span></label>
                                            <small><i>O aluno terá uma etapa de resumo para realizar após a etapa de estudar o conteúdo.</i></small>
                                        </div>
                                        <div className="edb-margin-top edb-margin-bottom">
                                            <label>Período de entrega inicial</label>
                                            <div className="adap-input-icon-container">
                                                <DatePicker className="adap-input"
                                                    selected={study.dtStartStudy}
                                                    onChange={this.onChangeDtInicio}
                                                    startDate={study.dtStartStudy}
                                                    useWeekdaysShort
                                                    selectsStart
                                                    showTimeSelect
                                                    dateFormat="dd/MM/yy HH:mm"
                                                    onFocus={(e) => (isMobile.any?e.target.readOnly = true:null)}
                                                    timeFormat="HH:mm"
                                                    timeCaption="Horário"
                                                    timeIntervals={5} />
                                                <i className="adap-input-icon far fa-calendar-alt"></i>
                                            </div>

                                            <label>Período de entrega final</label>
                                            <div className="adap-input-icon-container">
                                                <DatePicker className="adap-input"
                                                    selected={study.dtEndStudy}
                                                    onChange={this.onChangeDtFim}
                                                    endDate={study.dtEndStudy}
                                                    useWeekdaysShort
                                                    selectsStart
                                                    showTimeSelect
                                                    dateFormat="dd/MM/yy HH:mm"
                                                    onFocus={(e) => (isMobile.any?e.target.readOnly = true:null)}
                                                    timeFormat="HH:mm"
                                                    timeCaption="Horário"
                                                    timeIntervals={5} />
                                                <i className="adap-input-icon far fa-calendar-alt"></i>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div>
                                    <div className="edb-margin-top">
                                        {

                                            (this.props.conteudos || []).map((item, idx) =>
                                                <ItemSelecionarConteudo {...item} key={"itemSelConteudo" + idx} onClickVisualizar={this.onClickVisualizarConteudo} />
                                            )}
                                    </div>
                                </div>

                            </div>)
                        },
                        {
                            title: "Selecionar Alunos",
                            content: (<div>
                                <h4 className="edb-text-bold edb-margin-none">Selecionar Alunos</h4>
                                <div className="edb-margin-top edb-margin-bottom">
                                    <CheckboxTree
                                        nodes={treeViewAlunosEstudo.nodes}
                                        checked={treeViewAlunosEstudo.checked}
                                        expanded={treeViewAlunosEstudo.expanded}
                                        onCheck={this.onCheckTree}
                                        onExpand={expanded => this.props.practiceContainer.setState({ treeViewAlunosEstudo: { ...treeViewAlunosEstudo, expanded } })}

                                        showExpandAll={false}
                                        icons={{
                                            check: <i className="far fa-check-square" ></i>,
                                            uncheck: <i className="far fa-square" ></i>,
                                            halfCheck: <i className="far fa-minus-square" ></i>,
                                            expandClose: <i className="fas fa-chevron-down"></i>,
                                            expandOpen: <i className="fas fa-chevron-up"></i>,
                                            parentClose: <div style={{ width: 0 }}></div>,
                                            parentOpen: <div style={{ width: 0 }}></div>,
                                            leaf: <div style={{ width: 0 }}></div>
                                        }}
                                    />
                                </div>

                            </div>)
                        },
                    ]}
                />
                {this.state.showModalVisualizarConteudo && <ModalDetalheConteudo study={this.props.study} isOpen={this.state.showModalVisualizarConteudo} onCloseModal={this.onCloseModalVisualizarConteudo} hideAdd={true}/>}
            </React.Fragment>);
    }
}

export default ModalAddEstudo;